// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle-gray {\n  border-radius: 50%;\n  border: 1px solid #BFBFCA;\n  height: 21px;\n  width: 21px;\n  margin: 2px; }\n\n.characterization-radio--container {\n  cursor: pointer;\n  display: flex;\n  gap: 10px; }\n\n.characterization-radio--label p {\n  margin-bottom: 0px !important; }\n", ""]);
// Exports
module.exports = exports;
